<template>
    <div class="column-option co-date">
        <input type="hidden" v-model="valueExt">
        <date-picker v-model="innerDate" :value-type="'format'"
                     :editable="false" :clearable="false"
                     :format="'MM-YYYY'" :type="'month'"></date-picker>
    </div>
</template>

<script>
import DatePicker from "vue-datepicker-next";
import 'vue-datepicker-next/index.css';

export default {
    name: "date-option",
    components: { DatePicker },
    props: ['option', 'index', 'value'],
    model: {
        prop: 'value',
        event: 'valuechange'
    },
    data(){
        return {
            innerDate: this.getExternalValue()
        }
    },
    methods: {
        getExternalValue(){
            if(typeof this.value === 'undefined') return importApp.getDefaultOptionValue(this.option);
            if(typeof this.value[this.option] === 'undefined') return importApp.getDefaultOptionValue(this.option);
            if(Array.isArray(this.value)) return importApp.getDefaultOptionValue(this.option);

            let extVal = this.value[this.option];

            return extVal.substr(3); // drop first 3 symbols with date
        }
    },
    watch: {
        innerDate: {
            handler(newVal, oldVal){
                this.valueExt = newVal
            }
        }
    },
    computed: {
        valueExt: {
            get: function () {
                if(typeof this.value === 'undefined') return importApp.getDefaultOptionValue(this.option);
                if(typeof this.value[this.option] === 'undefined') return importApp.getDefaultOptionValue(this.option);
                if(Array.isArray(this.value)) return importApp.getDefaultOptionValue(this.option);

                let a = this.innerDate; // Без этого не работает xD

                return this.value[this.option];
            },
            set: function (value) {
                let val = this.value;
                val[this.option] = value;

                //console.log(value);

                this.value[this.option] = '01-' + value;

                this.$emit('valuechange', val);
                this.$emit('change', val, this.index);

            }
        }
    }
}
</script>

<style scoped>

</style>
